import { render, staticRenderFns } from "./ListPezziOperatore.vue?vue&type=template&id=4a5eea77&"
import script from "./ListPezziOperatore.vue?vue&type=script&lang=js&"
export * from "./ListPezziOperatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports